
import { Record } from "./fable_modules/fable-library-js.5.17.0/Types.js";
import { class_type, record_type, string_type } from "./fable_modules/fable-library-js.5.17.0/Reflection.js";

export class Flags extends Record {
    constructor(apiBaseUrl, apiKey, buildId) {
        super();
        this.apiBaseUrl = apiBaseUrl;
        this.apiKey = apiKey;
        this.buildId = buildId;
    }
}

export function Flags_$reflection() {
    return record_type("Viewer.Elm.Flags", [], Flags, () => [["apiBaseUrl", string_type], ["apiKey", string_type], ["buildId", string_type]]);
}

export class InitOptions extends Record {
    constructor(node, flags) {
        super();
        this.node = node;
        this.flags = flags;
    }
}

export function InitOptions_$reflection() {
    return record_type("Viewer.Elm.InitOptions", [], InitOptions, () => [["node", class_type("Browser.Types.HTMLElement", undefined)], ["flags", Flags_$reflection()]]);
}

//# sourceMappingURL=Elm.js.map
